export type ChampagneColor = 'RED' | 'WHITE' | 'ROSE';

export const ChampagneColor = {
  Red: 'RED' as ChampagneColor,
  White: 'WHITE' as ChampagneColor,
  Rose: 'ROSE' as ChampagneColor,
};
